import React from 'react';
import { Trash2, Plus, Minus } from 'lucide-react';
import { useCart } from '../contexts/CartContext';

const CartItem = ({ item }) => {
  const { updateQuantity, removeFromCart } = useCart();

  return (
    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-testid={`cart-item-${item.id}`}>
      <div className="flex gap-4">
        {/* Image */}
        <img
          src={item.image_url || 'https://via.placeholder.com/100'}
          alt={item.name}
          className="w-24 h-24 object-cover rounded-lg"
        />

        {/* Details */}
        <div className="flex-1">
          <h3 className="text-gray-900 font-semibold mb-1" data-testid="cart-item-name">{item.name}</h3>
          <p className="text-cyan-400 font-bold" data-testid="cart-item-price">
            {item.price.toLocaleString('fr-DZ')} DA
          </p>

          {/* Quantity Controls */}
          <div className="flex items-center gap-3 mt-3">
            <button
              onClick={() => updateQuantity(item.id, item.quantity - 1)}
              className="bg-white text-gray-900 p-1 rounded hover:bg-gray-200 transition"
              data-testid={`decrease-quantity-${item.id}`}
            >
              <Minus className="w-4 h-4" />
            </button>
            <span className="text-gray-900 font-semibold" data-testid={`cart-item-quantity-${item.id}`}>
              {item.quantity}
            </span>
            <button
              onClick={() => updateQuantity(item.id, item.quantity + 1)}
              className="bg-white text-gray-900 p-1 rounded hover:bg-gray-200 transition"
              data-testid={`increase-quantity-${item.id}`}
            >
              <Plus className="w-4 h-4" />
            </button>
          </div>
        </div>

        {/* Subtotal & Remove */}
        <div className="flex flex-col items-end justify-between">
          <button
            onClick={() => removeFromCart(item.id)}
            className="text-red-500 hover:text-red-400 transition"
            data-testid={`remove-item-${item.id}`}
          >
            <Trash2 className="w-5 h-5" />
          </button>
          <p className="text-gray-900 font-bold" data-testid={`cart-item-subtotal-${item.id}`}>
            {(item.price * item.quantity).toLocaleString('fr-DZ')} DA
          </p>
        </div>
      </div>
    </div>
  );
};

export default CartItem;